module.exports = __webpack_public_path__ + "img/hr-brown-fluff-03.3f1f8007.png";